export const ERGON_SERVICE_PROVIDER_ID = 'ERGONETP';

/**
 * TODO @Casey Sinclair maybe we should me this methods to address-lookup itself.
 * I had to remove @origin-digital/address-lookup dep from sales-common-types-fns as it was failing typecheck
 * Ideally sales-common-types-fns should not depend on rest of the mono repo libs
 */

export const isErgon = (address: any) =>
  address.elecDetails?.serviceProviderId === ERGON_SERVICE_PROVIDER_ID;

export const isErgonSolar = (address: any): boolean =>
  !!(isErgon(address) && address.elecDetails?.hasSolarPanels);
